<div class="sec-title">
    <h1>Liste des maquettes de propositions</h1>
</div>
<div class="col-6 col-md-6 d-flex justify-content-end">
    <a class="btn btn-success" routerLink="../maquette/ajouter" role="button"><i class="bi bi-plus-circle"></i> Ajouter une maquette</a>
  </div>
<div><a class="btn btn-action" href="/gestion" routerLink="/gestion" role="button"><i class="bi bi-arrow-90deg-left"></i> retour à gestion</a></div>

<ul class="list-inline">
    <li *ngFor="let template of templateList; let i = index;">
        <div class="card col-lg-6 col-md-12 me-3 mt-3">
            <div class="card-body">
              <h5 class="card-title"> <a routerLink="../maquette/{{template.template_id}}/editer">{{template.template_name}}</a></h5>
              
              <a routerLink="../maquette/{{template.template_id}}/editer" class="btn btn-primary">Editer</a>
            </div>
        </div>
    </li>
</ul>
